import React from "react";
import { Link } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";
import "./Category.scss";
import { pathMaker } from "../../../../utils/helperFunctions";
import ekia from "../../../../assets/images/logo/logo.png";
const Category = ({ item, active }) => {
  return (
    <div className="category-result">
      <div className="category-result-icon">
        <img
          src={item.file.length !== 0 ? pathMaker(item.file.url) : ekia}
          alt={item.txt}
        />
      </div>
      <div className="d-flex flex-column">
        <h4 className="category-result-title mr-t-8 font-14-500">{item.txt}</h4>
        <Link
          to={`/category/${item.id}?page=1`}
          className="category-result-link"
          onClick={(e) => active(false)}
        >
          <span className="category-result-link-text">
            مشاهده همه کالاهای دسته
          </span>
          <span className="category-result-link-icon">
            <FiChevronLeft />
          </span>
        </Link>
      </div>
    </div>
  );
};

export default Category;
